$shm_list_head $mol_view
	title \
	filter? \
	add? null
	add_title \Добавить
	close? null
	close_hint \Закрыть
	settings_hint \Click to show settings
	sort_by? \
	sort_order? \
	sort_options *
		created \Дата создания
		changed \Дата изменения
		title \Наименование
	group_content /
	sort_content /
		<= Sort $shm_sort
			sort_order? <=> sort_order? \
			sort_by? <=> sort_by? \
			options <= sort_options
	filter_content /
	settings_content /
	sub /
		<= Head $mol_view
			sub /
				^ head_content /$mol_view_content
					<= Title $mol_view
						sub /
							<= title
				^ add_content /
					<= Add $mol_button_minor
						click? <=> add? null
						sub /
							<= Add_icon $mol_icon_plus
							<= add_title
				^ close_content /
					<= Close $mol_button_minor
						hint <= close_hint
						click? <=> close? null
						sub /
							<= Close_icon $mol_icon_close
		<= Controls $mol_view
			sub /
				<= Filter $mol_search
					query? <=> filter? \
				<= Settings $mol_pick
					hint <= settings_hint
					trigger_content /
						<= Settings_trigger_icon $mol_icon_dots_vertical
					bubble_content /
						<= Settings_content $mol_list
							sub <= settings_content
	Group_label $mol_labeler
		title \Группировка
		content <= group_content
	Sort_label $mol_labeler
		title \Сортировка
		content <= sort_content
	Filter_label $mol_labeler
		title \Фильтрация
		content <= filter_content
